import { requestV2, requestV2Internal } from './request'
import { findRegionByLocale } from '@/common/region-locale'
import { SEOData } from './seo.service'

type News = {
  tabTitle?: string
  docId: number
  mediaUrl: string
  title: string
  secondTitle: string
  content: string
  created: number
  type: 'news' | 'media' | 'blog'
  other: Array<Omit<News, 'others'>>
  /** 上一篇文章，如果没有则为 null */
  beforeArticle: Omit<News, 'others'> | null
  date: string
  jumpUrl: string
  typeTitle: string
  isOutUrl: boolean
  outUrl: string
  recommendProducts?: Array<{
    title: string
    desc: string
    item: string[]
    mediaUrl: string
    jumpUrl: string
    id: number
  }>
  seoData?: SEOData | null
}

export type ResponseData = Array<{
  title: string
  item: Array<News>
}>

export type NewsList = {
  count: number
  item: Array<News>
}

export type TopNewsListAndTypeList = {
  topNewsList: Array<{
    created?: number

    content: string | number
    docId: string
    jumpUrl: string
    mediaUrl: string
    secondTitle: string
    title: string
    type: 'news' | 'blog'
    typeTitle: string
    other: Array<Omit<TopNewsListAndTypeList['topNewsList'], 'others'>>
    date: string
  }>
  typeList: Array<{
    title: string
    type: NewsType
  }>
  topTitle: string
  tabTitle: string
  seoData?: SEOData | null
}

export type NewsType = '' | 'top' | 'media' | 'news' | 'blog'

// 客户文章（新闻资讯）列表
export async function getNewsList(
  pagination: { offset: number; limit: number },
  type: NewsType,
  locale: string
): Promise<NewsList> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2('/news/list', { ...pagination, typeDocId: type, ...params })
  return res
}

getNewsList.swrkey = (locale: string, articleType: string) => `/${locale}/api/front/v2/news/list/${articleType}`

export async function getNewsListInternal(
  pagination: { offset: number; limit: number },
  type: NewsType,
  locale: string
): Promise<NewsList> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2Internal('/news/list', { ...pagination, typeDocId: type, ...params })
  return res
}

getNewsListInternal.swrkey = (locale: string, articleType: string) => `/${locale}/api/front/v2/news/list/${articleType}`

// 新闻页 首页 topNewsList&typeList
export async function getNewsHome(locale: string): Promise<TopNewsListAndTypeList> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2('/news/home', params)
  return res
}

getNewsHome.swrkey = (locale: string) => `/${locale}/api/front/v2/news/home`

export async function getNewsHomeInternal(locale: string): Promise<TopNewsListAndTypeList> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2Internal('/news/home', params)
  return res
}

getNewsHomeInternal.swrkey = (locale: string) => `/${locale}/api/front/v2/news/home`

export type NewsDetailsData = News

// 获取文章（新闻资讯）详情
export async function getInternalNewsDetails(id: string | number, region: string): Promise<NewsDetailsData> {
  const res = await requestV2Internal('/news/info', { docId: id, region })
  return res
}

getInternalNewsDetails.swrkey = (locale: string) => `/${locale}/api/front/v2/news/info`
